App.addModule(function(app) {

    app.on('loaded', () => {
	    $(document).on('mouseenter mouseleave', 'img[data-alt-src]', function() {
		    var img = $(this);
		    var src = img.attr('src');
		    img.attr('src',img.data('alt-src'));
		    img.data('alt-src',src);
	    });
    })
})
